export default __webpack_public_path__ + "static/media/btcpay-directory-logo.6a437bbe.svg";